/**
 * @deprecated Do not use it. Use callbacks !!!!!!!!!!!!!!!
 */
export const switcher = {
    REFRESH_GRID: true,
    REFRESH_ACTIVE_GRID: false,
    REFRESH_GRADIENT: false,
    REFRESH_GRADIENT_VALUES: false,
    REFRESH_GEODATA: false,
    REFRESH_CONTEXT: false,
    REFRESH_DESIGN_SCHEME: false,
};
